import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Spin } from "antd";

import useUpdateMenu from "features/menus/hooks/useUpdateMenu";
import { errorNotification } from "utils/Utils";
import AppModal from "components/ui/AppModal";
import AppButton from "components/ui/AppButton";
import AppOutlineButton from "components/ui/AppOutlineButton";
import AppInput from "components/ui/AppInput";

function EditMenu({ menuState, updateState }) {
  const { t } = useTranslation();
  const { isLoading } = useSelector((state) => state.LoaderReducer);

  const menuUpdate = useUpdateMenu();
  const [editMenu, setEditMenu] = useState({
    values: {
      name: "",
      description: "",
      _id: "",
    },
    errors: {
      name: "",
      description: "",
    },
  });

  const handleChange = (key, value) => {
    setEditMenu((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [key]: value,
      },
      errors: {
        ...prevState.errors,
        [key]: "",
      },
    }));
  };
  const handleSetErrors = (key, value) => {
    setEditMenu((prevState) => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [key]: value,
      },
    }));
  };

  const EditSelectedMenu = async () => {
    if (!editMenu?.values?.name) {
      handleSetErrors("name", "Please enter menu name");
      return;
    }

    if (
      editMenu?.values?.description &&
      editMenu?.values?.description?.length < 5
    ) {
      handleSetErrors("description", "Please enter minimum 5 characters");
      return;
    }
    try {
      await menuUpdate({
        rowData: {
          baseLanguage: {
            name: editMenu?.values?.name,
          },
          ...(editMenu?.values?.description?.trim() && {
            description: editMenu?.values?.description,
          }),
          _id: editMenu?.values?._id,
        },
        event: menuState.isActive,
      });
    } catch (error) {
      errorNotification(error.message);
    } finally {
    }
  };
  const resetState = () => {
    setEditMenu({
      values: {
        name: "",
        description: "",
      },
      errors: {
        name: "",
        description: "",
      },
    });
  };

  useEffect(() => {
    if (menuState?.menuInfo) {
      setEditMenu({
        values: {
          name: menuState?.menuInfo?.baseLanguage?.name,
          description: menuState?.menuInfo?.description,
          _id: menuState?.menuInfo?._id,
        },
        errors: {
          name: "",
          description: "",
        },
      });
    }
  }, [menuState.editMenumodal, menuState?.menuInfo]);

  const handleClose = () => {
    updateState("editMenumodal", false);
    resetState();
  };

  const footer = (
    <div className="flex justify-end gap-3">
      <AppOutlineButton onClick={handleClose} disabled={isLoading}>
        {t("Cancel")}
      </AppOutlineButton>
      <AppButton onClick={EditSelectedMenu} loading={isLoading} disabled={isLoading}>
        {t("Save")}
      </AppButton>
    </div>
  );

  return (
    <div key={menuState?.menuInfo?._id}>
      <AppModal
        onClose={handleClose}
        footer={footer}
        title={t("Edit Menu")}
        width={500}
        open={menuState.editMenumodal}
      >
        <Spin spinning={isLoading}>
          <div className="py-2">
            <AppInput
              label={t("Menu Name")}
              placeholder={t("E.g. Delivery menu")}
              value={editMenu?.values?.name}
              mandatory
              error={editMenu?.errors?.name}
              onInput={(event) => handleChange("name", event.target.value)}
            />
          </div>
          <div className="py-2">
            <AppInput
              label={t("Menu description")}
              placeholder={t("E.g. menu for delivery")}
              value={editMenu?.values?.description}
              error={editMenu?.errors?.description}
              onInput={(event) => handleChange("description", event.target.value)}
            />
          </div>
        </Spin>
      </AppModal>
    </div>
  );
}

export default EditMenu;
